/**
 * Jobs Page
 * Coming soon page for job listings
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Footer } from '../../components';
import SEO from '../../components/common/SEO';

const Jobs = () => {
  return (
    <div className="lh-jobs-page min-h-screen bg-white">
      <SEO
        title="Jobs"
        description="Discover tech job opportunities curated by Lotus Arc Technologies. Find roles in software development, data science, DevOps, and more — coming soon."
        canonicalPath="/jobs"
        keywords={['tech jobs', 'software developer jobs', 'IT jobs India', 'remote developer jobs', 'data science jobs', 'career opportunities']}
      />
      <Navbar />

      <main className="lh-jobs__main pt-24 pb-12 min-h-screen flex items-center justify-center">
        <div className="lh-jobs__container max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {/* Coming Soon Content */}
          <div className="lh-jobs__content">
            <div className="lh-jobs__icon-wrapper mb-8 flex justify-center">
              <div className="lh-jobs__icon w-24 h-24 bg-primary-100 rounded-full flex items-center justify-center">
                <svg className="lh-jobs__icon-svg w-12 h-12 text-primary-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
            </div>

            <h1 className="lh-jobs__title text-4xl md:text-5xl font-bold text-dark-900 mb-4">
              Jobs Coming Soon!
            </h1>
            
            <p className="lh-jobs__subtitle text-xl text-dark-500 mb-8 max-w-2xl mx-auto">
              We're working on bringing you exciting job opportunities. Check back soon for career openings and positions.
            </p>

            {/* Features Preview */}
            <div className="lh-jobs__features grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
              <div className="lh-jobs__feature card p-6">
                <div className="lh-jobs__feature-icon text-primary-500 mb-4">
                  <svg className="w-8 h-8 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <h3 className="lh-jobs__feature-title text-lg font-semibold text-dark-900 mb-2">Job Listings</h3>
                <p className="lh-jobs__feature-description text-sm text-dark-500">
                  Browse through curated job opportunities
                </p>
              </div>

              <div className="lh-jobs__feature card p-6">
                <div className="lh-jobs__feature-icon text-primary-500 mb-4">
                  <svg className="w-8 h-8 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="lh-jobs__feature-title text-lg font-semibold text-dark-900 mb-2">Apply Directly</h3>
                <p className="lh-jobs__feature-description text-sm text-dark-500">
                  Apply to positions directly through our platform
                </p>
              </div>

              <div className="lh-jobs__feature card p-6">
                <div className="lh-jobs__feature-icon text-primary-500 mb-4">
                  <svg className="w-8 h-8 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                </div>
                <h3 className="lh-jobs__feature-title text-lg font-semibold text-dark-900 mb-2">Career Matching</h3>
                <p className="lh-jobs__feature-description text-sm text-dark-500">
                  Get matched with jobs based on your skills
                </p>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="lh-jobs__cta flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/courses"
                className="lh-jobs__cta-primary btn-primary inline-flex items-center justify-center gap-2"
              >
                <span>Explore Courses</span>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </Link>
              <Link
                to="/"
                className="lh-jobs__cta-secondary btn-outline inline-flex items-center justify-center gap-2"
              >
                <span>Back to Home</span>
              </Link>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Jobs;

